import { Navigate } from "react-router-dom";
import { Projects } from "../Projects/Projects";

export const OrgDashboard = () => {
  return (
    <Navigate to="/organization/dashboard/emission-tracking" replace />
    // <div>
    //   {/* <Projects /> */}
    //   <div className="text-red-500">Available Soon !!!</div>
    // </div>
  );
};
